<template>
  <div
    class="dropdown-container"
    @mouseover="showDropDown = true"
    @mouseleave="showDropDown = false"
  >
    <div class="nav-tab">
      <img :src="tab.img" />
      <span>{{ tab.text }}</span>
    </div>
    <div
      v-if="showDropDown"
      class="dropdown"
    >
      <div
        v-for="section in tab.sections"
        :key="section.id"
        class="section"
        :class="[tab.cols === 2 ? 'col-2' : '']"
      >
        <div
          v-if="section.text"
          class="section-title"
        >
          {{ section.text }}
        </div>
        <ul class="items">
          <div
            v-if="section.items.length === 0"
            class="item blank"
          >
            ---
          </div>
          <template v-for="item in section.items">
            <template v-if="item.link">
              <a
                :key="item.id"
                :href="item.link"
                :target="item.target"
              >
                <li class="item">
                  {{ item.text }}
                </li>
              </a>
            </template>
            <template v-else>
              <li
                :key="item.id"
                class="item"
                @click="item.clickFunc"
              >
                {{ item.text }}
              </li>
            </template>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { httpMixin } from 'library/mixins/http';

export default {
  mixins: [httpMixin],
  props: {
    tab: Object,
  },
  data() {
    return {
      showDropDown: false,
    };
  },
};
</script>

<style scoped lang="scss">
@import 'dv/lib/SASS/_vars.scss';
$breakWidth: 1285px;
.dropdown-container {
  position: relative;
  z-index: 25;

  &:hover,
  .nav-tab:hover {
    cursor: pointer;

    span:hover {
      cursor: pointer;
    }
  }

  .nav-tab {
    display: flex;
    align-items: center;
    height: 100%;
    border-right: 1px solid lighten($scouting-gray, 10%);
    padding: 5px;
    &:hover {
      background: $blackFade40;
    }
    @media screen and (max-width: $break-medium) {
      padding: 1px;
    }

    span {
      width: 100%;
      min-width: 50px;
      text-align: center;
      color: white;
      cursor: default;
      @media screen and (max-width: $breakWidth) {
        display: none;
      }
    }
    img {
      width: 30px;
      max-width: 100%;
      height: auto;
      margin-right: 5px;
    }
  }

  .dropdown {
    position: absolute;
    left: 0;
    top: 100%;
    min-width: 200px;
    white-space: nowrap;
    margin: 0;
    border-radius: 0 0 4px 4px;
    color: black;
    box-shadow: 0 0 0.44444em black;

    display: inline-flex;
    flex-direction: row;
    flex-wrap: wrap;
    cursor: default;

    .section {
      width: 100%;
      &.col-2 {
        width: 50%;
      }

      .section-title {
        padding: 3px;
        background-color: $indBlue;
        color: white;
        text-transform: uppercase;
        font-size: 12px;
      }

      .item {
        width: 100%;
        list-style: none;
        padding: 3px;
        border-bottom: 1px solid #c3c5c7;
        background-color: $listItemBG;
        font-size: 12px;

        &:hover:not(.blank) {
          color: white;
          background-color: $listItemBGHover;
          cursor: pointer;
        }
      }

      a {
        color: black;
      }
      a:hover {
        color: white;
      }
    }
  }
}
</style>
